import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _dec2, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { reduxForm, Field, propTypes } from "redux-form";
import loginValidation from "./loginValidation";
import Card from "../Card/Card";
import strings from "./strings";
import { Link } from "react-router";
import { LLTextField, LLCheckbox, LLSubmitButton } from "../FormElements";
import { SecondaryButton } from "components";
import { connect } from "react-redux";
var localizedStrings = strings("en");
var LoginForm = (_dec = connect(function (state, ownProps) {
  return {
    theme: state.theme
  };
}, {}), _dec2 = reduxForm({
  form: "login",
  validate: loginValidation
}), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(LoginForm, _Component);

  var _super = _createSuper(LoginForm);

  function LoginForm() {
    var _this;

    _classCallCheck(this, LoginForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error;
      var inputComponent = type === "checkbox" ? /*#__PURE__*/React.createElement(LLCheckbox, _extends({}, input, {
        style: {
          marginTop: 10,
          marginBottom: 20
        },
        label: label
      })) : /*#__PURE__*/React.createElement(LLTextField, _extends({}, input, {
        type: type,
        placeholder: label
      }));
      return /*#__PURE__*/React.createElement("div", {
        className: "form-group ".concat(error && touched ? "has-error" : "")
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-12"
      }, inputComponent, error && touched && /*#__PURE__*/React.createElement("span", {
        className: "glyphicon glyphicon-remove form-control-feedback"
      }), error && touched && /*#__PURE__*/React.createElement("div", {
        style: {
          color: "red"
        }
      }, /*#__PURE__*/React.createElement("strong", null, error)))));
    });

    return _this;
  }

  _createClass(LoginForm, [{
    key: "render",
    value: function render() {
      var _this$props$theme$log, _this$props$theme;

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          error = _this$props.error;
      return /*#__PURE__*/React.createElement("div", {
        className: "row center-xs middle-xs",
        style: {
          height: "100%"
        }
      }, /*#__PURE__*/React.createElement(Card, {
        className: "col-xs-12 col-sm-6 col-md-4"
      }, /*#__PURE__*/React.createElement("img", {
        src: (_this$props$theme$log = (_this$props$theme = this.props.theme) === null || _this$props$theme === void 0 ? void 0 : _this$props$theme.logo) !== null && _this$props$theme$log !== void 0 ? _this$props$theme$log : "https://likeabucket.s3.amazonaws.com/user_upload/216/BJs5ANF5M.png",
        style: {
          maxWidth: 300
        },
        alt: "Login logo"
      }), /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement(Field, {
        name: "email",
        type: "text",
        component: this.renderInput,
        label: localizedStrings.emailLabel
      }), /*#__PURE__*/React.createElement(Field, {
        name: "password",
        type: "password",
        component: this.renderInput,
        label: localizedStrings.passwordLabel
      }), /*#__PURE__*/React.createElement(Field, {
        name: "doPersist",
        type: "checkbox",
        component: this.renderInput,
        label: localizedStrings.persistLoginLabel
      }), error && /*#__PURE__*/React.createElement("p", {
        style: {
          color: "red"
        }
      }, /*#__PURE__*/React.createElement("strong", null, "The email address or password", /*#__PURE__*/React.createElement("br", null), "you entered is incorrect.")), /*#__PURE__*/React.createElement(SecondaryButton, {
        label: "Log In"
      })), /*#__PURE__*/React.createElement(Link, {
        to: "/reset/request",
        className: "left-xs",
        style: {
          display: "inline-block",
          color: "rgb(139,139,139)",
          textDecoration: "none",
          marginTop: "10px"
        }
      }, "Forgot your password?")));
    }
  }]);

  return LoginForm;
}(Component), _defineProperty(_class2, "propTypes", _objectSpread({}, propTypes)), _temp)) || _class) || _class);
export { LoginForm as default };